/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Feature_Plans_TitleInputs */

const en_platform_feature_plans_title = /** @type {(inputs: Platform_Feature_Plans_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training plans`)
};

const pl_platform_feature_plans_title = /** @type {(inputs: Platform_Feature_Plans_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plany treningowe`)
};

/**
* | output |
* | --- |
* | "Training plans" |
*
* @param {Platform_Feature_Plans_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_feature_plans_title = /** @type {((inputs?: Platform_Feature_Plans_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Feature_Plans_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_feature_plans_title(inputs)
	return en_platform_feature_plans_title(inputs)
});